import React, { useState, useEffect, useRef,useLayoutEffect } from 'react';
import {
    faCircleQuestion
} from '@fortawesome/free-solid-svg-icons';
import dynamic from 'next/dynamic'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from './ModalCus'
import { useAddCartMutation, useGetCartMutation } from '../../Store/Features/CartAPI';
import { addItemToCart } from '../../Store/reducers/cartSlice';
import { useDispatch, useSelector } from 'react-redux';
import Link from 'next/link';
import Toast from '../../Common/Toast';
import EnquireNow from './EnquireNow';
import BuyNow from './BuyNow';
import EnquireBundleDiscount from './EnquireBundleDiscount';
const ExitIntent = dynamic(() => import('../../../components/Common/ExitIntentForm', { ssr: false }));



const BorderBtn = dynamic(() => import('../../Common/BorderBtn', { ssr: false }));


export default function Prices({ data }) {
    const [addCart, { isError, isSuccess }] = useAddCartMutation();
    const [getCart] = useGetCartMutation();
    const dispatch = useDispatch();
    const cartState = useSelector((state) => state.cart.items)
    const [price, setPrice] = useState([]);
    const [selectedPrice, setSelectedPrice] = useState(null);
    const [selectedPriceTypeId, setSelectedPriceTypeId] = useState(null);
    const [isAdded, setIsAdded] = useState(false);

    

    useLayoutEffect(() => {
        if (data) {
            for(let i=0; i<cartState.length; i++){
                if (cartState[i]?.product_id === data?.report_data?._id) {
                    setIsAdded(true)
                    const selectedValue = cartState[i].license_price;
                    setSelectedPrice(selectedValue);
                    setSelectedPriceTypeId(cartState[i].license_type);
                    break;
                } else{
                    setIsAdded(false)
                }

            }
            // cartState?.map((item, index) => {
            // })
        }else{
            setIsAdded(false)
        }
    }, [data])

    useLayoutEffect(() => {
        if (data?.report_data?.is_sale == true) {
            const sortedPrices = data?.report_data?.prices ? [...data.report_data?.prices].sort((a, b) => parseInt(a.discounted_price) - parseInt(b.discounted_price)) : [];
            setPrice(sortedPrices);
            if (sortedPrices.length > 0) {
                setSelectedPrice(sortedPrices[0].discounted_price);
                setSelectedPriceTypeId(sortedPrices[0].price_type_id);
            }
        } else {
            const sortedPrices = data?.report_data?.prices ? [...data.report_data?.prices].sort((a, b) => parseInt(a.price) - parseInt(b.price)) : [];
            setPrice(sortedPrices);

            if (sortedPrices.length > 0) {
                setSelectedPrice(sortedPrices[0].price);
                setSelectedPriceTypeId(sortedPrices[0].price_type_id);
            }
        }


    }, [data]);

    const handlePriceChange = (event, priceType) => {
        const selectedValue = event.target.value;
        setSelectedPrice(selectedValue);
        setSelectedPriceTypeId(priceType);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };
     

    

    const addingCart = () => {
        const token = localStorage.getItem('access_token');
        addCart({
            "product_id": data.report_data._id,
            "tmp_id": token,
            "user_id": "",
            "license_id": selectedPriceTypeId
        }).then((res_data) => {
            setIsAdded(true)
            getCart({
                "tmp_id": localStorage.getItem('access_token'),
                "user_id": ""
            }).then((res) => {
                dispatch(addItemToCart(res.data?.data));
            })
            
            Toast(res_data?.data.message)
        })
    }
    const sectionRef = useRef(null);

    // Function to handle button click and scroll to the section
    const scrollToSection = () => {
        sectionRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };
    return (
        <>
            <div ref={sectionRef} className='bg-gray-100 border rounded-md dark:bg-black'>
                <div className='flex justify-between p-4'>
                    <div>
                        <p onClick={openModal} className='my-0 text-sm text-[#1e5df3] font-semibold cursor-pointer'> 
                            <FontAwesomeIcon icon={faCircleQuestion} className='text-[#1e5df3]' /> License Type
                        </p>
                    </div>
                    <div>
                        {/* <p className='my-0 underline text-[#e70e02] text-sm font-bold'>USD</p> */}
                    </div>
                </div>
                <div className='text-center'>
                    {selectedPrice && selectedPriceTypeId && (
                        <>
                            <p className='text-[#1e5df3] text-md font-semibold my-0 uppercase'>{selectedPriceTypeId}</p>
                            {/* <p className='my-0 text-lg font-semibold'>${selectedPrice}</p> */}
                        </>
                    )}
                </div>
                <hr />
                <div className='p-4'>
                    {price.map((data, index) => {
                        return (
                            <div key={index} className='flex justify-between py-2'>
                                <div className='w-full'>
                                    <input
                                        type="radio"
                                        value={data.is_discounted ? data.discounted_price : data.price}
                                        id={`priceType${index}`} // Unique id for each input
                                        className='mr-2'
                                        name='license'
                                        onChange={(e) => handlePriceChange(e, data.price_type_id)}
                                        // Check the first radio button by default
                                        defaultChecked={(data?.price_type_id == selectedPriceTypeId)? 'checked': false }
                                    />
                                    <label
                                        className='text-sm capitalize cursor-pointer' 
                                        htmlFor={`priceType${index}`} 
                                    >
                                        {data.price_type_id}
                                    </label>
                                </div>
                                {   data?.is_discounted &&
                                    <p class="my-0 ml-2 text-green-600 whitespace-nowrap">({parseInt(((data?.price-data?.discounted_price)*100)/data?.price)}% OFF)</p>
                                }
                                {/* <div>
                                    {data.is_discounted ?
                                    <>
                                        <span className='text-red-500 line-through text-[12px]'>${data.price}</span>
                                        <span className='text-green-800'>${data.discounted_price}</span>
                                    </>
                                    :
                                    '$' + data.price}
                                </div> */}
                            </div>
                        );
                    })}
                    <EnquireNow sampleSlug={data?.report_data?.name}/>
                    <BuyNow sampleSlug={data?.report_data?.name} addingCart={addingCart} isAdded={isAdded}/>
                    <EnquireBundleDiscount sampleSlug={data?.report_data?.name}/>
                   
                    {/* {isAdded ?
                        <>
                            <BorderBtn 
                                onClick={() => {
                                    addingCart()
                                    
                                }}
                                customClass="mt-2 w-full hightLightBtn text-white font-semibold py-2 px-6 rounded text-sm"
                                buttonTitle="Go To Cart"
                                buttonLink="/cart"
                            />
                        </>
                        :
                        <button onClick={addingCart} className="mt-2 flex justify-center bg-[#1e5df3] w-full mx-auto hover:bg-[#1b5df3] text-black font-semibold py-2 px-6 rounded text-sm licPriTypeBtn">
                            Buy Now
                        </button>
                    } */}
                </div>
                <Modal isOpen={isModalOpen} onClose={closeModal} />
                <ExitIntent
                    product_name={data?.report_data?.name}
                    title={data?.report_data?.h1_title ? data?.report_data?.h1_title : (data?.report_data?.slug)?.replace(/-/g, ' ') + ' ' + 'Sample Page'}
                    shortDescription={'Get a Sneak Peek at the Latest' + ' ' + (data?.report_data?.slug)?.replace(/-/g, ' ') + ' ' + 'Report'}
                    page_name="Exit Intent Report Profile"
                    form_name="exit-intent-report-profile"
                    slug={data?.report_data?.slug}
                />
            </div>

            <div className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-between h-20 px-4 pt-2 bg-gray-100 border-t border-gray-300 lg:hidden">
                <Link href={'/sample-request/' + data.report_data?.slug}>
                    <div className="text-center px-6 py-3 bg-[#1b5df3] text-white whitespace-nowrap">
                        <p className='m-0 text-base text-white'>Request Sample</p>
                    </div>
                </Link>
                <div onClick={scrollToSection}>
                    <div className="text-center px-6 py-3 bg-[#1b5df3] text-white whitespace-nowrap">
                        <p className='m-0 text-base text-white'>View Pricing</p>
                    </div>
                </div>
            </div>
        </>
    );
}